module.exports = __webpack_public_path__ + "img/广州冷库2.cb243cc5.jpg";